module.exports = __webpack_public_path__ + "fonts/VetoSansCond-BoldItalic_1.951a3527.eot";